import { Dispatch } from 'redux';

import { AppState } from '../reducers';
import { verifyBestillingSkjema, verifyContactInfo, verifySoknadSkjema } from './application';
import { sendApplication } from './sendApplication';
import { sendOrder } from './sendOrder';
import { actionTypes, AppActions } from './types';

type Action<T> = import('./types').Action<T>;

export interface OpenStepAction extends Action<typeof actionTypes.OPEN_STEP> {
    type: typeof actionTypes.OPEN_STEP;
    payload: {
        destinationStep: number;
    };
}

export type StepsActions = OpenStepAction;

export const openStep = (destinationStep: number): OpenStepAction => ({
    type: actionTypes.OPEN_STEP,
    payload: { destinationStep },
});

/* Step 1 - Contact */
export const contactNextEvent =
    (amountEnabled: boolean) =>
    async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
        dispatch(verifyContactInfo(amountEnabled));
        const { epost, mobiltelefon, kredittbelop } = getState().application.errors;
        if (!epost && !mobiltelefon && (!amountEnabled || !kredittbelop)) dispatch(openStep(3));
    };

/* Step 2 - About */
export const aboutNextEvent =
    () =>
    async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
        dispatch(verifySoknadSkjema());
        const { application } = getState();
        if (application.valid) {
            dispatch(openStep(4));
        }
    };

/* Step 3 - KDK */
export const kdkNextEvent =
    () =>
    async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
        await sendApplication(dispatch, getState);
    };

/* Step 4 - Summary */
export const summaryNextEvent =
    () =>
    async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
        dispatch(verifyBestillingSkjema());
        const { application } = getState();
        const { valid } = application;
        if (valid) {
            await sendOrder(dispatch, getState);
        }
    };
